import {
  fieldTypeIcon,
  fieldTypeLabel,
  makeField,
} from '../../shared/fieldTypes';
import { prefillFit } from '../../shared/prefillSources';
import { canonicalField } from './snapshot';

// Saved-field library glue (plan §3.5 createSavedFormField, §5.6).
// A saved field is { id, name, base_type, config: { label, help,
// placeholder, required, map, config } }. Inserting one always mints a new
// fld_ id; SavedFormField.id is never used as a field id.

const text = (value, fallback) =>
  typeof value === 'string' ? value : fallback;

export const fieldFromSaved = (saved, id) => {
  const base = saved ? makeField(saved.base_type, id) : null;
  if (!base) return null;
  const c =
    (saved.config && typeof saved.config === 'object' && saved.config) || {};
  const map = c.map && prefillFit(c.map, base.type) ? c.map : null;
  return canonicalField({
    ...base,
    label: text(c.label, base.label),
    help: text(c.help, base.help),
    placeholder: text(c.placeholder, base.placeholder),
    required: typeof c.required === 'boolean' ? c.required : base.required,
    map,
    acct: false,
    config: { ...base.config, ...(c.config || {}) },
  });
};

// Uploaded images belong to one form, so a saved copy never keeps them.
const ASSET_KEYS = ['banner_asset_id', 'asset_id'];

// Field → CreateSavedFormFieldInput (global library in v1: account_id null).
export const savedFieldInput = (field) => {
  const config = { ...field.config };
  ASSET_KEYS.forEach((key) => {
    if (key in config) config[key] = null;
  });
  return {
    name: (field.label || '').trim() || fieldTypeLabel(field),
    base_type: field.type,
    account_id: null,
    config: {
      label: field.label,
      help: field.help,
      placeholder: field.placeholder,
      required: field.required,
      map: field.map,
      config,
    },
  };
};

// The field a saved entry adds, enough to name its type (an Agreement is a
// checkbox with config.single).
const savedShape = (saved) => ({
  type: saved.base_type,
  config: (saved.config && saved.config.config) || {},
});

export const savedTypeLabel = (saved) => fieldTypeLabel(savedShape(saved));

export const savedTypeIcon = (saved) => fieldTypeIcon(savedShape(saved));

// "Short Answer · required" line under a saved field's name.
export const savedFieldDetail = (saved) => {
  const required = !!(saved.config && saved.config.required);
  return `${savedTypeLabel(saved)}${required ? ' · required' : ''}`;
};
